import { put, call, takeEvery } from "redux-saga/effects";
import { getTokenRequest, getUnauthenticateToken } from "../utils/requests";
import { reset } from "redux-form";

import { errorMessages } from '../utils/content';

export function* getTokenFromEndpoint() {
  try {
    yield put({
      type: "SHOW_MODAL",
      modalType: "loading",
      message: "Loading..."
    });
    const data = yield call(getTokenRequest);
    yield put({
      type: "SET_TOKEN",
      token: data
    });
    yield put({
      type: "HIDE_MODAL",
      modalType: "loading"
    });
  } catch (error) {
    yield put({
      type: "DESTROY_TOKEN"
    });
    yield put({
      type: "HIDE_MODAL",
      modalType: "loading"
    });
    yield put({
      type: "SHOW_NOTIFICATION",
      notificationType: "error",
      message: errorMessages.fetchingTokenFailed
    });
  }
}

// Watch for token request and execute action to set token
export function* watchTokenRequest() {
  yield takeEvery("GET_TOKEN", getTokenFromEndpoint);
}

function* unauthenticateTokenOnEndpoint() {
  try {
    yield put({
      type: "SHOW_MODAL",
      modalType: "loading",
      message: "Loading..."
    });
    yield call(getUnauthenticateToken);
  } catch (error) {
  } finally {
    yield put({
      type: "CLEAR_LOAN"
    });
    yield put({
      type: "CLEAR_PAYMENT"
    });
    yield put(reset("LoanPayment"));
    yield put({
      type: "DESTROY_TOKEN"
    });
    yield put({
      type: "HIDE_MODAL",
      modalType: "loading"
    });
  }
}

// Watch for token destroy request and execute action to destroy token
export function* watchUnauthenticateToken() {
  yield takeEvery("UNAUTHENTICATE_TOKEN", unauthenticateTokenOnEndpoint);
}



// WEBPACK FOOTER //
// ./src/sagas/token.sagas.js